import { Fade, Alert, IconButton } from "@mui/material";
import { FC, ReactNode } from "react";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import { COLOR_GREY_9 } from "shared/theme/colors";
import { CheckCircleIcon } from "shared/theme/icons/CheckCircleIcon";
import { CloseIcon } from "shared/theme/icons/CloseIcon";
import { InfoOutlinedIcon } from "shared/theme/icons/InfoOutlinedIcon";
import { StyledSnackbar, AlertType } from "./styled";

type SnackbarProps = {
  open: boolean;
  success: boolean;
  message: ReactNode;
  onClose: () => void;
};

const Snackbar: FC<SnackbarProps> = ({ open, success, message, onClose }) => {
  return (
    <StyledSnackbar
      type={success ? AlertType.Success : AlertType.Error}
      open={open}
      autoHideDuration={7000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      TransitionComponent={Fade}
    >
      <Alert
        onClose={onClose}
        severity={success ? "success" : "error"}
        variant="filled"
        sx={{ width: "100%" }}
        icon={
          success ? <CheckCircleIcon /> : <InfoOutlinedIcon color="#F44336" />
        }
        action={
          <IconButton onClick={onClose} sx={{ padding: 0 }}>
            <CloseIcon color={COLOR_GREY_9} />
          </IconButton>
        }
      >
        <FlexColumn>{message}</FlexColumn>
      </Alert>
    </StyledSnackbar>
  );
};

export default Snackbar;
